import { default as _91id_93ZJFKK0s52fMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue?macro=true";
import { default as accountsqkmmp95x57Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue?macro=true";
import { default as analyticsNyjqClKzdGMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue?macro=true";
import { default as contactsqw0nybrbuoMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue?macro=true";
import { default as indexCOUIX2XKcpMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue?macro=true";
import { default as mailboxesbOSukQsky0Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue?macro=true";
import { default as newvIsV8zm72aMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue?macro=true";
import { default as scheduleV0D9i6lspXMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue?macro=true";
import { default as _91sequenceId_93uApJiGf9vvMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue?macro=true";
import { default as indexFAVH1FExevMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue?macro=true";
import { default as new3eoCLGnCd5Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue?macro=true";
import { default as outreach9djcanENslMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue?macro=true";
import { default as setupiOhTVUJI2yMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue?macro=true";
import { default as _91icp_93xm4aqn4WPzMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue?macro=true";
import { default as indexuF2bwUmNv3Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue?macro=true";
import { default as campaignspMFPYDeZRnMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue?macro=true";
import { default as discoverBsZU61THsJMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue?macro=true";
import { default as indexV6gXeJYMVYMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue?macro=true";
import { default as opensaDnUlOTIqyMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue?macro=true";
import { default as repliesz6aE0BGscvMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue?macro=true";
import { default as _91listId_93RtpqDpuGMzMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue?macro=true";
import { default as allztLui3E1RrMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue?macro=true";
import { default as minept6WfwmigxMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue?macro=true";
import { default as sequencesJaRGREFVkZMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue?macro=true";
import { default as accountEK50tjLlFWMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue?macro=true";
import { default as crm4C2CkHu9aJMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/crm.vue?macro=true";
import { default as engaged_45accountsyWMGnMLGh6Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue?macro=true";
import { default as engaged_45contactsh3osTb8yNSMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue?macro=true";
import { default as exportsavRp9FYLazMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue?macro=true";
import { default as forbidden_45accountsHy7RM93eeCMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue?macro=true";
import { default as forbidden_45contactsJk18hyltkkMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue?macro=true";
import { default as importsQt8tRkusTdMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue?macro=true";
import { default as indexDS7cn9BFnWMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsPlznLDa3O1Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue?macro=true";
import { default as mailboxQUgJzuZqkeMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue?macro=true";
import { default as notificationsMhBcn1R2OVMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue?macro=true";
import { default as organizationKhclYIpG6GMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue?macro=true";
import { default as repliesP0MJdzEue7Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue?macro=true";
import { default as settingsQJIaMmCd6rMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue?macro=true";
import { default as advanced_45icpAm286BLvoRMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue?macro=true";
import { default as advancedkALvXhtz49Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue?macro=true";
import { default as employeesPDrgK1e0DcMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue?macro=true";
import { default as job_45openingstfXoeEQ2f0Meta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue?macro=true";
import { default as newskEsZvzhGjjMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue?macro=true";
import { default as websitesKly3BZSfDWMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue?macro=true";
import { default as signind1RA9SjwmcMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue?macro=true";
import { default as signupix4QczV70QMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue?macro=true";
import { default as testvnDYkWQD7GMeta } from "/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue?macro=true";
export default [
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue")
  },
  {
    name: campaignspMFPYDeZRnMeta?.name,
    path: "/campaigns",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue"),
    children: [
  {
    name: "campaigns-icp",
    path: ":icp()",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue"),
    children: [
  {
    name: "campaigns-icp-accounts",
    path: "accounts",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue")
  },
  {
    name: "campaigns-icp-analytics",
    path: "analytics",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue")
  },
  {
    name: outreach9djcanENslMeta?.name,
    path: "outreach",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue"),
    children: [
  {
    name: _91sequenceId_93uApJiGf9vvMeta?.name,
    path: ":sequenceId()",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue"),
    children: [
  {
    name: "campaigns-icp-outreach-sequenceId-contacts",
    path: "contacts",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId",
    path: "",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-mailboxes",
    path: "mailboxes",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-new",
    path: "new",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-schedule",
    path: "schedule",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue")
  }
]
  },
  {
    name: "campaigns-icp-outreach",
    path: "",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue")
  },
  {
    name: "campaigns-icp-outreach-new",
    path: "new",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue")
  }
]
  },
  {
    name: "campaigns-icp-setup",
    path: "setup",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue")
  }
]
  },
  {
    name: "campaigns",
    path: "",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue")
  }
]
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue")
  },
  {
    name: "opens",
    path: "/opens",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue")
  },
  {
    name: "replies",
    path: "/replies",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue")
  },
  {
    name: "saved-listId",
    path: "/saved/:listId()",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue")
  },
  {
    name: "saved-all",
    path: "/saved/all",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue")
  },
  {
    name: "saved-mine",
    path: "/saved/mine",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue")
  },
  {
    name: "sequences",
    path: "/sequences",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue")
  },
  {
    name: settingsQJIaMmCd6rMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue")
  },
  {
    name: "settings-crm",
    path: "crm",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/crm.vue")
  },
  {
    name: "settings-engaged-accounts",
    path: "engaged-accounts",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue")
  },
  {
    name: "settings-engaged-contacts",
    path: "engaged-contacts",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue")
  },
  {
    name: "settings-exports",
    path: "exports",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue")
  },
  {
    name: "settings-forbidden-accounts",
    path: "forbidden-accounts",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue")
  },
  {
    name: "settings-forbidden-contacts",
    path: "forbidden-contacts",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue")
  },
  {
    name: "settings-imports",
    path: "imports",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-mailbox",
    path: "mailbox",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue")
  },
  {
    name: "settings-organization",
    path: "organization",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue")
  },
  {
    name: "settings-replies",
    path: "replies",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue")
  }
]
  },
  {
    name: "signals-advanced-icp",
    path: "/signals/advanced-icp",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue")
  },
  {
    name: "signals-advanced",
    path: "/signals/advanced",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue")
  },
  {
    name: "signals-employees",
    path: "/signals/employees",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue")
  },
  {
    name: "signals-job-openings",
    path: "/signals/job-openings",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue")
  },
  {
    name: "signals-news",
    path: "/signals/news",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue")
  },
  {
    name: "signals-websites",
    path: "/signals/websites",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/codebuild/output/src4283975271/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue")
  }
]